import React from 'react'
import Box from "@mui/material/Box";

import {ListDealsPageHeader} from "./ListDealsPageHeader";

import {ListDealsList} from "./ListDealsList";

import './ListDealsPage.scss'
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const ListDealsPage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    return (
        <React.Fragment>
            <Box
                style={{
                    display: isTabletOrMobile ? '' : 'flex',
                    height: isTabletOrMobile ? 'auto': '100vh',
                    overflow: isTabletOrMobile ? 'auto' : 'hidden',
                    flexDirection: isTabletOrMobile ? 'column' : '',
                    background: "var(--color-border-subtle)",
                }}
            >
                <Box
                    style={{
                        display: isTabletOrMobile ? 'flex' : '',
                        padding: isTabletOrMobile ? '30px' : '60px 30px',
                        flexGrow: 2,
                        maxWidth: isTabletOrMobile ? '100%' : '',
                        flexDirection: isTabletOrMobile ? 'column' : ''
                    }}
                    id={"ListDealsPage"}
                >
                    <ListDealsPageHeader/>
                    <ListDealsList />
                </Box>
            </Box>
        </React.Fragment>
    )
}